// Importar y exportar respuestas rápidas en CSV. Dos columnas: atajo y mensaje.
// Se escribe con BOM y comillas para que Excel lo abra bien con tildes y con
// mensajes de varias líneas, y al leer se acepta coma o punto y coma (el Excel
// en español guarda con punto y coma).

const BOM = String.fromCharCode(0xfeff);

const HEADER_SHORTCUT = ["atajo", "shortcut"];
const HEADER_MESSAGE = ["mensaje", "message"];

const escapeCell = (value) => {
  const text = String(value ?? "");
  return /[",;\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** Texto CSV (con BOM) de una lista de { shortcut, message }. */
export const toCsv = (items) => {
  const lines = [["atajo", "mensaje"], ...items.map((i) => [i.shortcut, i.message])];
  return `${BOM}${lines.map((row) => row.map(escapeCell).join(",")).join("\r\n")}\r\n`;
};

const detectDelimiter = (text) => {
  const firstLine = text.split(/\r?\n/, 1)[0] || "";
  const semicolons = (firstLine.match(/;/g) || []).length;
  const commas = (firstLine.match(/,/g) || []).length;
  return semicolons > commas ? ";" : ",";
};

/** Filas (arrays de celdas) de un CSV, con comillas y saltos de línea dentro. */
export const parseRows = (rawText) => {
  const raw = String(rawText || "");
  const text = raw.startsWith(BOM) ? raw.slice(1) : raw;
  const delimiter = detectDelimiter(text);
  const rows = [];
  let row = [];
  let cell = "";
  let quoted = false;

  for (let i = 0; i < text.length; i += 1) {
    const char = text[i];
    if (quoted) {
      if (char === '"' && text[i + 1] === '"') {
        cell += '"';
        i += 1;
      } else if (char === '"') {
        quoted = false;
      } else {
        cell += char;
      }
    } else if (char === '"') {
      quoted = true;
    } else if (char === delimiter) {
      row.push(cell);
      cell = "";
    } else if (char === "\n" || char === "\r") {
      if (char === "\r" && text[i + 1] === "\n") i += 1;
      row.push(cell);
      rows.push(row);
      row = [];
      cell = "";
    } else {
      cell += char;
    }
  }
  if (cell !== "" || row.length) {
    row.push(cell);
    rows.push(row);
  }
  return rows.filter((r) => r.some((c) => String(c).trim() !== ""));
};

/**
 * Lista de { shortcut, message } desde el texto de un CSV. Si la primera fila
 * es la cabecera (atajo/mensaje o shortcut/message) se salta; si no, se toman
 * las dos primeras columnas tal cual.
 */
export const parseCsv = (rawText) => {
  const rows = parseRows(rawText);
  if (!rows.length) return [];

  const first = rows[0].map((c) => String(c).trim().toLowerCase());
  const hasHeader =
    HEADER_SHORTCUT.includes(first[0]) && HEADER_MESSAGE.includes(first[1]);
  const body = hasHeader ? rows.slice(1) : rows;

  return body.map((r) => ({
    shortcut: String(r[0] ?? "").trim(),
    message: String(r[1] ?? "").trim(),
  }));
};
